export enum TextInputTypes {
  text = 'text',
  email = 'email',
  phone = 'phone',
  password = 'password',
  number = 'number',
}
